import { ref, watch } from '@vue/composition-api'
// import store from '@/store'

export default function useRefPriorityHandler(props, emit) {
    // ------------------------------------------------
    // taskLocal
    // ------------------------------------------------
    const refPriorityLocal = ref(JSON.parse(JSON.stringify(props.priority.value)))
    const resetRefPriorityLocal = () => {
      refPriorityLocal.value = JSON.parse(JSON.stringify(props.priority.value))
    }
    watch(props.priority, () => {
      resetRefPriorityLocal()
    })
  
    // ------------------------------------------------
    // isEventHandlerSidebarActive
    // * Clear form if sidebar is closed
    // ! We can hide it using @hidden event
    // ------------------------------------------------
    // watch(props.isEventHandlerSidebarActive, val => {
    //   // ? Don't reset event till transition is finished
    //   if (!val) {
    //     setTimeout(() => {
    //       clearForm.value()
    //     }, 350)
    //   }
    // })
  
    const onSubmit = () => {
      const refPriorityData = JSON.parse(JSON.stringify(refPriorityLocal))
  
      // * If event has id => Edit Event
      // Emit event for add/update event
      if (props.priority.value.id) emit('update-ref-priority', refPriorityData.value)
      else emit('add-ref-priority', refPriorityData.value)
  
      // Close sidebar
      emit('update:is-add-new-ref-priority-sidebar-active', false)
    }
  
  
    return {
      // fetchCategories,
      // fetchProducts,
      // fetchTags,
      // fetchPriorities,
      // fetchTeams,
      // fetchUsers,
      refPriorityLocal,
      resetRefPriorityLocal,
      onSubmit,
    }
  }